export enum CRMStatus {
  RESEARCH = 'RESEARCH',
  DISCUSSION = 'DISCUSSION',
  WATCHFUL_WAITING = 'WATCHFUL_WAITING',

  RECOMMEND_NO_INVESTMENT = 'RECOMMEND_NO_INVESTMENT',
  RECOMMEND_AWAITING_KEY_INFLECTION = 'RECOMMEND_AWAITING_KEY_INFLECTION',
  RECOMMEND_INVEST_BUY = 'RECOMMEND_INVEST_BUY',
  RECOMMEND_INVEST_SELL = 'RECOMMEND_INVEST_SELL',
  RECOMMEND_INVEST_SHORT = 'RECOMMEND_INVEST_SHORT',
  RECOMMEND_INVEST_COVER = 'RECOMMEND_INVEST_COVER',


  DL_REJECTS_RECOMMEND_NO_INVESTMENT = 'DL_REJECTS_RECOMMEND_NO_INVESTMENT',
  DL_REJECTS_RECOMMEND_AWAITING_KEY_INFLECTION = 'DL_REJECTS_RECOMMEND_AWAITING_KEY_INFLECTION',
  DL_REJECTS_RECOMMEND_INVESTMENT = 'DL_REJECTS_RECOMMEND_INVESTMENT',

  DL_APPROVES_RECOMMEND_NO_INVESTMENT = 'DL_APPROVES_RECOMMEND_NO_INVESTMENT',
  DL_APPROVES_RECOMMEND_AWAITING_KEY_INFLECTION = 'DL_APPROVES_RECOMMEND_AWAITING_KEY_INFLECTION',
  DL_APPROVES_RECOMMEND_INVESTMENT = 'DL_APPROVES_RECOMMEND_INVESTMENT',
  DL_APPROVES_RECOMMEND_INVESTMENT_BUY = 'DL_APPROVES_RECOMMEND_INVESTMENT_BUY',
  DL_APPROVES_RECOMMEND_INVESTMENT_SELL = 'DL_APPROVES_RECOMMEND_INVESTMENT_SELL',
  DL_APPROVES_RECOMMEND_INVESTMENT_COVER = 'DL_APPROVES_RECOMMEND_INVESTMENT_COVER',
  DL_APPROVES_RECOMMEND_INVESTMENT_SHORT = 'DL_APPROVES_RECOMMEND_INVESTMENT_SHORT',

  PM_REJECTS_RECOMMEND_INVESTMENT = 'PM_REJECTS_RECOMMEND_INVESTMENT',
  PM_APPROVES_RECOMMEND_INVESTMENT = 'PM_APPROVES_RECOMMEND_INVESTMENT',
  PM_APPROVES_RECOMMEND_INVESTMENT_BUY = 'PM_APPROVES_RECOMMEND_INVESTMENT_BUY',
  PM_APPROVES_RECOMMEND_INVESTMENT_SELL = 'PM_APPROVES_RECOMMEND_INVESTMENT_SELL',
  PM_APPROVES_RECOMMEND_INVESTMENT_COVER = 'PM_APPROVES_RECOMMEND_INVESTMENT_COVER',
  PM_APPROVES_RECOMMEND_INVESTMENT_SHORT = 'PM_APPROVES_RECOMMEND_INVESTMENT_SHORT',

  INVESTMENT_NOT_MADE_NOT_OUR_CHOICE = 'INVESTMENT_NOT_MADE_NOT_OUR_CHOICE',
  INVESTMENT_NOT_MADE_OUR_CHOICE = 'INVESTMENT_NOT_MADE_OUR_CHOICE',
  INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED = 'INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED',
  INVESTMENT_NOT_MADE_COMPANY_CANCELLED = 'INVESTMENT_NOT_MADE_COMPANY_CANCELLED',
  INVESTMENT_MADE_SUBOPTIMAL = 'INVESTMENT_MADE_SUBOPTIMAL',
  INVESTMENT_MADE_OPTIMAL = 'INVESTMENT_MADE_OPTIMAL',
  CLOSED_BEFORE_DECISION = 'CLOSED_BEFORE_DECISION',
  SILENCED = 'SILENCED',
  UNSILENCED = 'UNSILENCED',

  RECOMMEND_PASS_ON_MEETING = 'RECOMMEND_PASS_ON_MEETING',
  RECOMMEND_TAKE_MEETING = 'RECOMMEND_TAKE_MEETING',
}

export const CRMStatusLabels: Record<CRMStatus, string> = {
  [CRMStatus.RESEARCH]: 'Research',
  [CRMStatus.DISCUSSION]: 'Discussion',
  [CRMStatus.WATCHFUL_WAITING]: 'Watchful Waiting',
  [CRMStatus.RECOMMEND_NO_INVESTMENT]: 'Recommend Pass',
  [CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION]: 'Recommend Pass - Pending KI',
  [CRMStatus.RECOMMEND_INVEST_BUY]: 'Recommend Buy',
  [CRMStatus.RECOMMEND_INVEST_SELL]: 'Recommend Sell',
  [CRMStatus.RECOMMEND_INVEST_SHORT]: 'Recommend Short',
  [CRMStatus.RECOMMEND_INVEST_COVER]: 'Recommend Cover',
  [CRMStatus.DL_REJECTS_RECOMMEND_NO_INVESTMENT]: 'DL Rejected - Recommend Pass',
  [CRMStatus.DL_REJECTS_RECOMMEND_AWAITING_KEY_INFLECTION]: 'DL Rejected - Recommend Pass (Pending KI)',
  [CRMStatus.DL_REJECTS_RECOMMEND_INVESTMENT]: 'DL Rejected - Recommend Invest',
  [CRMStatus.DL_APPROVES_RECOMMEND_NO_INVESTMENT]: 'DL Approved - Recommend Pass',
  [CRMStatus.DL_APPROVES_RECOMMEND_AWAITING_KEY_INFLECTION]: 'DL Approved - Recommend Pass (Pending KI)',
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT]: 'DL Approved - Recommend Invest',
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_BUY]: 'DL Approved - Recommend Buy',
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SELL]: 'DL Approved - Recommend Sell',
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_COVER]: 'DL Approved - Recommend Cover',
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SHORT]: 'DL Approved - Recommend Short',
  [CRMStatus.PM_REJECTS_RECOMMEND_INVESTMENT]: 'PM Rejected - Recommend Invest',
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT]: 'PM Approved - Recommend Invest',
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_BUY]: 'PM Approved - Recommend Buy',
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SELL]: 'PM Approved - Recommend Sell',
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_COVER]: 'PM Approved - Recommend Cover',
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SHORT]: 'PM Approved - Recommend Short',
  [CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE]: 'Investment not made (not our choice)',
  [CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE]: 'Investment not made (our choice)',
  [CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED]: 'Investment not made (neutrally closed)',
  [CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED]: 'Investment not made (company cancelled deal)',
  [CRMStatus.INVESTMENT_MADE_SUBOPTIMAL]: 'Investment made (suboptimal)',
  [CRMStatus.INVESTMENT_MADE_OPTIMAL]: 'Investment made (optimal)',
  [CRMStatus.SILENCED]: 'Silenced',
  [CRMStatus.UNSILENCED]: 'Unsilenced',
  [CRMStatus.CLOSED_BEFORE_DECISION]: 'Closed Before Decision',
  [CRMStatus.RECOMMEND_PASS_ON_MEETING]: 'Recommend Pass on Meeting',
  [CRMStatus.RECOMMEND_TAKE_MEETING]: 'Recommend Take Meeting',
};

export const CRMStatusToStatusOptions: Record<CRMStatus, Array<CRMStatus>> = {
  [CRMStatus.RESEARCH]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.DISCUSSION]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
    ],
  [CRMStatus.WATCHFUL_WAITING]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.RECOMMEND_NO_INVESTMENT]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_NO_INVESTMENT,
    CRMStatus.DL_APPROVES_RECOMMEND_NO_INVESTMENT,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.DL_APPROVES_RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.RECOMMEND_INVEST_BUY]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_BUY,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.RECOMMEND_INVEST_SELL]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SELL,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.RECOMMEND_INVEST_SHORT]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SHORT,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.RECOMMEND_INVEST_COVER]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_COVER,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.CLOSED_BEFORE_DECISION,
    ],
  [CRMStatus.DL_REJECTS_RECOMMEND_NO_INVESTMENT]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.DL_REJECTS_RECOMMEND_AWAITING_KEY_INFLECTION]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_AWAITING_KEY_INFLECTION,
  ],
  [CRMStatus.DL_REJECTS_RECOMMEND_INVESTMENT]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.DL_APPROVES_RECOMMEND_NO_INVESTMENT]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_APPROVES_RECOMMEND_NO_INVESTMENT,
  ],
  [CRMStatus.DL_APPROVES_RECOMMEND_AWAITING_KEY_INFLECTION]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.DL_APPROVES_RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.PM_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_BUY]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.PM_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_BUY,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_BUY,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SELL]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.PM_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SELL,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SELL,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_COVER]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.PM_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_COVER,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_COVER,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SHORT]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.PM_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SHORT,
    CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SHORT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.PM_REJECTS_RECOMMEND_INVESTMENT]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.PM_REJECTS_RECOMMEND_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
    CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED,
    CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED,
  ],
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_BUY]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_BUY,
    CRMStatus.CLOSED_BEFORE_DECISION,
    CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED,
    CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED,
  ],
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SELL]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SELL,
    CRMStatus.CLOSED_BEFORE_DECISION,
    CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED,
    CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED,
  ],
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_COVER]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_COVER,
    CRMStatus.CLOSED_BEFORE_DECISION,
    CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED,
    CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED,
  ],
  [CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SHORT]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
    CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SHORT,
    CRMStatus.CLOSED_BEFORE_DECISION,
    CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED,
    CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED,
  ],
  [CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED,
    CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
  ],
  [CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED,
    CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
  ],
  [CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
  ],
  [CRMStatus.INVESTMENT_NOT_MADE_COMPANY_CANCELLED]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NEUTRALLY_CLOSED,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
  ],
  [CRMStatus.INVESTMENT_MADE_SUBOPTIMAL]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
  ],
  [CRMStatus.INVESTMENT_MADE_OPTIMAL]: [
    CRMStatus.INVESTMENT_NOT_MADE_OUR_CHOICE,
    CRMStatus.INVESTMENT_NOT_MADE_NOT_OUR_CHOICE,
    CRMStatus.INVESTMENT_MADE_OPTIMAL,
    CRMStatus.INVESTMENT_MADE_SUBOPTIMAL,
  ],
  [CRMStatus.SILENCED]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.CLOSED_BEFORE_DECISION]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.RECOMMEND_PASS_ON_MEETING]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.RECOMMEND_TAKE_MEETING]: [
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
  [CRMStatus.UNSILENCED]: [
    CRMStatus.RECOMMEND_TAKE_MEETING,
    CRMStatus.RECOMMEND_PASS_ON_MEETING,
    CRMStatus.RESEARCH,
    CRMStatus.DISCUSSION,
    CRMStatus.WATCHFUL_WAITING,
    CRMStatus.RECOMMEND_INVEST_BUY,
    CRMStatus.RECOMMEND_INVEST_SELL,
    CRMStatus.RECOMMEND_INVEST_SHORT,
    CRMStatus.RECOMMEND_INVEST_COVER,
    CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
    CRMStatus.RECOMMEND_NO_INVESTMENT,
    CRMStatus.CLOSED_BEFORE_DECISION,
  ],
};

export const DL_APPROVES_INVESTMENT_STATUSES: Array<CRMStatus> = [
  CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT,
  CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_BUY,
  CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SELL,
  CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_COVER,
  CRMStatus.DL_APPROVES_RECOMMEND_INVESTMENT_SHORT,
];

export const PM_APPROVES_INVESTMENT_STATUSES: Array<CRMStatus> = [
  CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT,
  CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_BUY,
  CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SELL,
  CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_COVER,
  CRMStatus.PM_APPROVES_RECOMMEND_INVESTMENT_SHORT,
];

export const PENDING_STATUSES: Array<CRMStatus> = [
  CRMStatus.RECOMMEND_INVEST_BUY,
  CRMStatus.RECOMMEND_INVEST_SELL,
  CRMStatus.RECOMMEND_INVEST_SHORT,
  CRMStatus.RECOMMEND_INVEST_COVER,
  CRMStatus.RECOMMEND_NO_INVESTMENT,
  CRMStatus.RECOMMEND_AWAITING_KEY_INFLECTION,
  ...DL_APPROVES_INVESTMENT_STATUSES,
];

export const INVESTMENT_MADE_STATUSES: Array<CRMStatus> = [
  CRMStatus.INVESTMENT_MADE_OPTIMAL,
  CRMStatus.INVESTMENT_MADE_SUBOPTIMAL
];
